module.exports = __webpack_public_path__ + "static/media/ranking.150167eb.png";